module.exports = __webpack_public_path__ + "static/media/logo_dashboard.b74fdfe0.png";